import { sortBy } from "lodash";
import React from "react";

import { BlockRows } from "@brexhq/next/src/components/shared/BlockRows/BlockRows";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { HorizontalBlocksProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems/HorizontalBlocks";

import {
  RowBlocks,
  BlockWrapper,
  ColumnBlocks,
} from "./HorizontalBlocks.elements";

interface Props {
  theme: ModuleThemeType;
  data: HorizontalBlocksProps;
}

export const HorizontalBlocks = ({
  theme,
  data: {
    widthStyle,
    horizontalAlignment,
    verticalAlignment,
    gap = "none",
    horizontalBlockItems,
    // breakpoint at which blocks begin to stack vertically
    directionBreakpoint = "mobile",
    customStackOrder = false,
  },
}: Props) => {
  const numberOfBlocks = horizontalBlockItems.length;
  const sortedHorizontalBlockItems = () => {
    if (!customStackOrder) return horizontalBlockItems;
    // stackPositions should always be defined if customStackOrder is true, this is just an extra guard
    return sortBy(horizontalBlockItems, ["stackPosition"]);
  };

  return (
    <>
      <RowBlocks
        horizontalAlignment={horizontalAlignment}
        verticalAlignment={verticalAlignment}
        directionBreakpoint={directionBreakpoint}
        widthStyle={widthStyle}
        gap={gap}
      >
        {horizontalBlockItems.map((item) => (
          <BlockWrapper
            key={item._key}
            maxWidth={item.maxWidth}
            widthStyle={widthStyle}
            gap={gap}
            numberOfBlocks={numberOfBlocks}
            directionBreakpoint={directionBreakpoint}
          >
            <BlockRows
              rows={item.verticalBlockRows}
              theme={theme}
              alignment={item.rowAlignment}
            />
          </BlockWrapper>
        ))}
      </RowBlocks>
      <ColumnBlocks
        horizontalAlignment={horizontalAlignment}
        verticalAlignment={verticalAlignment}
        directionBreakpoint={directionBreakpoint}
        widthStyle={widthStyle}
        gap={gap}
      >
        {sortedHorizontalBlockItems().map((item) => (
          <BlockWrapper
            key={item._key}
            maxWidth={item.maxWidth}
            widthStyle={widthStyle}
            gap={gap}
            numberOfBlocks={numberOfBlocks}
            directionBreakpoint={directionBreakpoint}
          >
            <BlockRows
              rows={item.verticalBlockRows}
              theme={theme}
              alignment={item.rowAlignment}
            />
          </BlockWrapper>
        ))}
      </ColumnBlocks>
    </>
  );
};
